import React from 'react';
import PropTypes from 'prop-types';
import { ProgressCircle } from '@americanexpress/dls-react';

export const FxLoadingComponent = ({ size, title, ...otherProps }) => (
  <div className="flex flex-justify-center flex-align-items-center pad-responsive">
    <ProgressCircle size={size} title={title} {...otherProps} />
  </div>
);

FxLoadingComponent.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  title: PropTypes.string,
};

FxLoadingComponent.defaultProps = {
  size: 'lg',
  title: 'Loading',
};
